import { useState, useEffect } from 'react';

export const useColor = (colorName) => {
  switch (colorName) {
    case 'red': {
      return '#e84a49';
      break;
    }
    case 'blue': {
      return '#4a98ce';
      break;
    }
    case 'brown': {
      return '#baa3a0';
      break;
    }
    case 'green': {
      return '#234d5b';
      break;
    }
    case 'violet': {
      return '#a7a0cf';
      break;
    }
    case 'orange': {
      return '#f18841';
      break;
    }

    default: {
      return '#f18841';
      break;
    }
  }
  // useEffect(() => {
  //   if (typeof window !== 'undefined') {
  //     observer = new IntersectionObserver(([entry]) =>
  //       setIntersecting(entry.isIntersecting),
  //     );
  //   }

  //   observer?.observe(ref.current);
  //   // Remove the observer as soon as the component is unmounted
  //   return () => {
  //     observer?.disconnect();
  //   };
  // }, []);

  // return isIntersecting;
};
